import React from "react";
import { useEffect } from "react";
import ciApi from "services/ciApi";
import { useState } from "react";
import walletBalancingActions from "../../../actions/walletBalancingActions";
import walletBalancingInputFields from "./walletBalancingInputFields";
import generateEntityEditor from "../../../hocs/generateEntityEditor";
import getWalletBalancingInputFields from "./walletBalancingInputFields";

const WalletBalancingEditor = (props) => {
  const [inputFields, setInputFields] = useState([]);
  const [clientId, setClientId] = useState(null);

  const handleDataFetch = async () => {
    try {
      const response = await ciApi.call({
        httpMethod: "get",
        endpoint: `/wallet_balancing/${props.id}/wallet_profile`,
      });

      if (!response.isSuccess) {
        throw new Error(`Erro ao buscar perfil de carteira: ${response.data}`);
      }

      const data = response.data;
      return data;
    } catch (error) {
      console.error("Erro ao buscar perfil de carteira:", error);
      return [];
    }
  };

  useEffect(() => {
    const fetchColumns = async () => {
      const response = await handleDataFetch();
      const walletProfile = response.walletProfile;

      const walletBalancingInputFields =
        getWalletBalancingInputFields(walletProfile);

      setInputFields(walletBalancingInputFields);
      setClientId(response.clientId);
    };

    fetchColumns();
  }, [props.id]);

  const Component = generateEntityEditor({
    entitySingularString: "walletBalancing",
    entityPluralString: "walletBalancings",
    entityActions: walletBalancingActions,
    returnRoutePath: `/client-wallet-balancing/${clientId}`,
    fields: inputFields,
  });

  return <Component id={props.id} {...props} />;
};

// const WalletBalancingEditor = generateEntityEditor({
//   entitySingularString: "walletBalancing",
//   entityPluralString: "walletBalancings",
//   entityActions: walletBalancingActions,
//   returnRoutePath: "/client-wallet-balancing/",
//   fields: walletBalancingInputFields,
// });

export default WalletBalancingEditor;
